export default __webpack_public_path__ + "static/media/simpleEcommerce.1924ab53.png";